import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
// import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import HeaderMenu from 'components/Header/HeaderMenu';
import ThemeProvider from 'components/Theme';
import Home from 'components/Home/Home';
// import Lives from 'components/Lives/Lives';
import LivePlayer from 'components/UI/Orchestrator/LivePlayerOrchestrator';
import Replays from 'components/Replays/Replays';
import ReplayPlayer from 'components/Replays/ReplayPlayer';
import Contact from 'components/Contact/Contact';
import Help from 'components/Help/Help';
import BrowserBarrier from 'components/UI/BrowserBarrier/BrowserBarrier';
// import Agenda from 'components/Agenda/Agenda';
import DetectBrowser from 'components/UI/DetectBrowser/DetectBrowser'
import Account from 'components/Account/Account';
import AdminAccount from 'components/UI/Account/AdminAccount';
import AdminEvent from 'components/UI/Event/AdminEvent';
import AdminNews from 'components/UI/News/AdminNews';
import AdminFaq from 'components/UI/Faq/AdminFaq';
import AdminTheme from 'components/UI/Theme/AdminTheme';
import AdminMessage from 'components/UI/Message/AdminMessage';
import AdminCMS from 'components/UI/Cms/AdminCms';
import Feedback from "components/UI/Feedback/WrapperFeedback";
import AdminFeedback from "components/UI/Feedback/AdminFeedback";
import AdminOrchestrator from "components/UI/Orchestrator/AdminOrchestrator";
import AdminOrchestratorIndex from "components/UI/Orchestrator/AdminOrchestratorIndex";
import AdminQuiz from "components/UI/Quiz/AdminQuiz";
import AdminUtm from "components/UI/Utm/AdminUtm";

import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import NoMatch from 'components/NoMatch';
import Logout from 'components/Logout';
import Login from 'components/Login/Login';
import Registration from 'components/Registration/Registration';
import Legal from 'components/Legal/Legal';
import Confidentiality from 'components/Confidentiality/Confidentiality';
// import HomeSubscribe from "./HomeSubscribe";
import { ResetPasswordRequest, ResetPasswordChallenge } from 'components/UI/ResetPassword';
import {
  login as initialeLogin,
  isStateKnown as authStateKnown,
  getCurrentUserRole,
  // isLoggedIn,
} from '../ducks/authentication';
import queryString from 'query-string';
import properCase from 'mout/string/properCase';
// import capitalize from "lodash/capitalize";
import '../App.scss';

const styles = {};

class App extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    document.title = 'Canal ' + properCase(process.env.REACT_APP_SITE === 'dermato_rs' ? 'Dermato RS' : process.env.REACT_APP_SITE);
    this.props.onMount();
  }
  render() {
    const {
      // loggedIn,
      userRole,
      authStateKnown,
      classes,
      // width,
      // $$data
    } = this.props;
    // console.log({authStateKnown})
    return (
      <div className={classes.root}>
        <ThemeProvider>
          <CssBaseline />
          <ScrollToTopOnMount />
          <DetectBrowser/>
          <If condition={authStateKnown === true}>
            <BrowserBarrier />
            <Router>
              <Switch>
                <Route exact path={'/'} component={({ match }) => <Home />} />
                {/* <Route
                  exact
                  path={"/subscribe"}
                  component={({ match }) => <Home subscribe={true} />}
                  /> */}
                  <Route exact path={'/registration'} component={({ match }) => <Registration />} />
                  <Route
                    exact={true}
                    path={'/subscribe/:id'}
                    component={({ match }) => <Home subscribe={true} themeId={match.params.id} />}
                    />
                  <Route exact path={'/login'} component={({ match }) => <Login />} />
                  <Route exact path={'/help'} component={({ match }) => <Help />} />
                  <Route exact path={'/contact'} component={({ match }) => <Contact />} />
                  <Route path={'/legal'} component={() => <Legal />} />
                  <Route path={'/confidentiality'} component={() => <Confidentiality />} />
                  <Route
                    exact
                    path={'/live/:id'}
                    component={({ match }) => <LivePlayer match={match} onPanelToggle={this._panelToggle} />}
                    />

                  <Route exact path={'/logout'} component={() => <Logout />} />
                  <Route path="/rpwd" component={({ match }) => <ResetPasswordRequest match={match} />} />
                  <Route path="/cpwd" component={() => <ResetPasswordChallenge />} />
                  <Route path={'/replays/:id'} component={({ match }) => <ReplayPlayer match={match} />} />
                  <Route path={'/replays'} component={({ match }) => <Replays />} />
                  <Route
                    path="/staff/account/:action/:id"
                    component={({ match }) => <AdminAccount match={match} />}
                    />
                  <Route
                    path="/staff/account/:action"
                    component={({ match }) => <AdminAccount match={match} />}
                    />
                  <Route path="/staff/account" component={() => <AdminAccount />} />

                  <Route
                    path="/staff/event/:action/:id"
                    component={({ match }) => <AdminEvent match={match} />}
                    />
                  <Route path="/staff/event/:action" component={({ match }) => <AdminEvent match={match} />} />
                  <Route path="/staff/event" component={() => <AdminEvent />} />

                  <Route
                    path="/staff/utm/:action/:id"
                    component={({ match }) => <AdminUtm match={match} />}
                    />
                  <Route path="/staff/utm/:action" component={({ match }) => <AdminUtm match={match} />} />
                  <Route path="/staff/utm" component={() => <AdminUtm />} />


                  <Route path="/staff/news/:action/:id" component={({ match }) => <AdminNews match={match} />} />
                  <Route path="/staff/news/:action" component={({ match }) => <AdminNews match={match} />} />

                  <Route path="/staff/faq/:action/:id" component={({ match }) => <AdminFaq match={match} />} />
                  <Route path="/staff/faq/:action" component={({ match }) => <AdminFaq match={match} />} />

                  <Route path="/staff/feedback/:eventId/:action/:id" component={({match}) => <AdminFeedback match={match}/>}/>
                  <Route path="/staff/feedback/:eventId/:action" component={({match}) => <AdminFeedback match={match}/>}/>
                  <Route path="/feedback/:eventId" component={({match}) => <Feedback match={match}/>}/>

                  <Route exact path={"/staff/quiz/:eventId/:action/:id"} component={({ match }) => <AdminQuiz match={match}/>} />
                  <Route exact path={"/staff/quiz/:eventId/:action"} component={({ match }) => <AdminQuiz match={match}/>} />

                  <Route exact path={"/staff/orchestrator/:eventId/:action"} component={({ match }) => <AdminOrchestrator match={match}/>} />
                  <Route exact path={"/staff/orchestrator/list"} component={({ match }) => <AdminOrchestratorIndex match={match}/>} />

                  <Route
                    path="/staff/theme/:action/:id"
                    component={({ match }) => <AdminTheme match={match} />}
                    />
                  <Route path="/staff/theme/:action" component={({ match }) => <AdminTheme match={match} />} />

                  <Route path="/staff/cms/:action/:id" component={({ match }) => <AdminCMS match={match} />} />
                  <Route path="/staff/cms/:action" component={({ match }) => <AdminCMS match={match} />} />

                  <Route
                    path="/staff/message/:action/:id"
                    component={({ match }) => <AdminMessage match={match} />}
                    />
                  <Route
                    path="/staff/message/:action"
                    component={({ match }) => <AdminMessage match={match} />}
                    />
                  <Route path="/account" component={({ match }) => <Account match={match} />} />
                  <Route component={() => <NoMatch />} />
                </Switch>
              </Router>
            </If>
          </ThemeProvider>
        </div>
      );
    }
  }

  function mapStateToProps(state) {
    const props = {
      authStateKnown: authStateKnown(state),
      // loggedIn: isLoggedIn(state),
      userRole: getCurrentUserRole(state),
    };
    return props;
  }
  function mapDispatchToProps(dispatch) {
    return {
      onMount: () => {
        const uri = queryString.parse(window.location.search);

        return dispatch(initialeLogin({ referer: uri.r }));
      },
    };
  }

  export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(App));



// WEBPACK FOOTER //
// ./src/components/App.js